import React from 'react';
import GivePage from './GivePage';

const BODY = `Give a one-time gift or set up a recurring monthly donation online using any major credit card. Online giving is quick, secure, and eligible for a tax receipt (Canadian gifts of $20 or more).

Our online giving portal is coming soon. In the meantime, please contact the parish office for assistance with online donations. Tax receipts are issued at the end of the year for all gifts received.`;

const GiveOnline = () => (
  <GivePage
    slug="give-online"
    title="Online Donation"
    contentKey="give_online_body"
    defaultBody={BODY}
  />
);

export default GiveOnline;
